import React from 'react';
import { oneDecimal } from '../../utils/numbersUtils';
import { t } from '../../i18n/i18n';

export const ScoreColumn = (percent = 0, isQualitative = false) => (
  <span
    className="font-weight-bold profiles-list-item-percent position-relative d-flex justify-content-center align-items-center"
    data-color="yellow"
  >
    <span
      className={`profiles-list-item-percent-subitem
      ${
        !percent
          ? 'no-score-bg'
          : percent < 75
          ? `mix-yellow-${Math.floor(percent)}`
          : `mix-green-${Math.floor(percent) - 75}`
      }`}
    />
    {percent === -1 ? '-' : isQualitative ? t('WITHOUT_SCORE') : oneDecimal(percent)}
  </span>
);
